import { Box, Flex, IconInfo, Text } from "@powerledger/ui-component-lib";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ArrowDownSVG, ArrowUpSVG } from "@/assets/icons";

import { ERCOT_HELPER_TEXT } from "./helpers";

const ErcotDetailsSection = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Box
      sx={{
        borderRadius: 8,
        border: "1px solid",
        borderColor: "textDarker",
        overflow: "hidden",
        bg: "rgba(255, 250, 235, .6)",
      }}
    >
      {/* Header */}
      <Flex
        onClick={() => setIsOpen(!isOpen)}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          cursor: "pointer",
          fontWeight: 500,
          fontFamily: "MintGroteskV08",
          color: "textDarker",
        }}
      >
        <Flex sx={{ gap: 1 }}>
          <IconInfo
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              svg: {
                width: 20,
                height: 20,
                path: {
                  fill: "primary.500",
                },
              },
            }}
          />

          <Text sx={{ fontSize: 2 }}>{t("ERCOT Registry Information")}</Text>
        </Flex>
        {isOpen ? <ArrowUpSVG /> : <ArrowDownSVG />}
      </Flex>

      {/* Content */}
      {isOpen && (
        <Flex
          as={"ul"}
          sx={{
            flexDirection: "column",
            gap: 2,
            p: 3,
            borderTop: "1px solid",
            borderColor: "textDarker",
            pl: 30,
          }}
        >
          {ERCOT_HELPER_TEXT.map((text) => (
            <Text
              as={"li"}
              key={text}
              sx={{
                fontSize: 1,
                fontWeight: 400,
                lineHeight: 1.6,
                color: "textDarker",
                fontFamily: "MintGroteskV08",
              }}
            >
              {text}
            </Text>
          ))}
        </Flex>
      )}
    </Box>
  );
};

export default ErcotDetailsSection;
